module.exports = __webpack_public_path__ + "static/img/btn_hexiaoma_nor.ab07295.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/btn_hexiaoma_nor.png
// module id = XpHf
// module chunks = 1